import React from 'react';

export default function () {
    return <p>Contact Customer support</p>;
}
